import { useEffect, useRef } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { HomePage } from "@/pages/HomePage";
import { EngineeringPage } from "@/pages/EngineeringPage";
import { AcademyPage } from "@/pages/AcademyPage";
import { CreativeLabPage } from "@/pages/CreativeLabPage";
import { routeMeta } from "@/data/siteContent";
import { trackPageView } from "@/lib/analytics";
import type { SiteRoute } from "@/types/site";

function MetaSync() {
  const location = useLocation();
  const lastTrackedPath = useRef("");

  useEffect(() => {
    const key = location.pathname as SiteRoute;
    const meta = routeMeta[key] ?? routeMeta["/"];
    document.title = meta.title;
    const description = document.querySelector('meta[name="description"]');
    if (description) {
      description.setAttribute("content", meta.description);
    }

    const currentPath = `${location.pathname}${location.search}${location.hash}`;
    if (lastTrackedPath.current !== currentPath) {
      trackPageView(currentPath);
      lastTrackedPath.current = currentPath;
    }
  }, [location.hash, location.pathname, location.search]);

  return null;
}

export function App() {
  return (
    <Layout>
      <MetaSync />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/engineering" element={<EngineeringPage />} />
        <Route path="/academy" element={<AcademyPage />} />
        <Route path="/creative-lab" element={<CreativeLabPage />} />
      </Routes>
    </Layout>
  );
}
